import { createStore } from 'vuex'

import general from './general'
import auth from '../modules/auth/store'
import budgets from '../modules/budgets/store'
import cohorts from '../modules/cohorts/store'
import typesOfService from '../modules/typesOfService/store'
import typesOfSubject from '../modules/typesOfSubject/store'
import teachers from '../modules/teachers/store'
import campus from '../modules/campus/store'
import academicsLevels from '../modules/academicLevel/store'
import pecunaryRights from '../modules/pecunaryRights/store'
import programs from '../modules/programs/store'

const store = createStore({
    modules: {
        general,
        auth,
        budgets,
        cohorts,
        typesOfService,
        teachers,
        campus,
        academicsLevels,
        pecunaryRights,
        typesOfSubject,
        programs
    }
})

export default store